import { render, staticRenderFns } from "./SoftwareStatistics.vue?vue&type=template&id=d1d9f3a4&scoped=true&"
import script from "./SoftwareStatistics.vue?vue&type=script&lang=js&"
export * from "./SoftwareStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareStatistics.vue?vue&type=style&index=0&id=d1d9f3a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d9f3a4",
  null
  
)

export default component.exports